// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___KYfcZ","body":"body___DlAqe"};